import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  ContentContainer,
  PageStyles,
  WelcomeBanner,
  WelcomeDescription,
} from './Welcome.styles';

export const ScreenWelcome: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Domination welcome screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination">
      <IonContent>
        <ContentContainer>
          <LogoWithAppName className="app-logo" withCaption={false} />
          <WelcomeBanner />
          <WelcomeDescription>
            I'm not here to please you. Unless you beg properly. Shall we begin
            shaping your mistress?
          </WelcomeDescription>
        </ContentContainer>

        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonText={'Yes, Mistress'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
        />
      </IonContent>
    </PageStyles>
  );
};
